/** 
 * @description(交易配置)的接口以及(商家发布商品)的相关接(短信消息)
 * @params config.newHttps.api
 *  */
import api from '../../api/index';
import config from '@/assets/config.json';
const state = {}
const mutations = {}
const getters = {}
const actions = {
//店铺的商品标准名称-资质
talentList({
  rootState,
  commit
}, opt) {
  return new Promise((resolve, reject) => {
    api.post(`${config.newHttps.api}/merchant/talent/list`,opt).then(data => {
      if (data.data) {
        resolve(data.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  });
},
//店铺的商品标准名称-资质-添加
talentAdd({
  rootState,
  commit
}, opt) {
  return new Promise((resolve, reject) => {
    api.post(`${config.newHttps.api}/merchant/store/standard/add`,opt).then(data => {
      if (data.data) {
        resolve(data.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  });
},
//店铺的商品标准名称-列表
strandList({
  rootState,
  commit
}, opt) {
  return new Promise((resolve, reject) => {
    api.get(`${config.newHttps.api}/merchant/store/standard`,{params:opt} ).then(data => {
      if (data.data) {
        resolve(data.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  });
},
  //交易配置
   configList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/merchant/order/setting`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //修改
   setConfigList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/merchant/order/setting/edit`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

   getshopIdName({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/shop/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  
  /**@param {发布商品-获取商家店铺-标签名称} */
   getshopstandardName({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/goods/standard/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  /**@param {发布商品-获取商家店铺-品牌名称} */
   getshopbrand({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/brand/list`, {params:opt}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  /**@param {发布商品-获取商家店铺-属性} */
  getshopproperty({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/property/${opt.standard_id}/${opt.goods_id}/${opt.sku_flag}`, {params:{token:opt.token}}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  /**
   * @param {发布/编辑商品-商品sku批量保存}
   */
  saveProductGg ({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/goodsspec/patchsave`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  /**@param {发布商品-获取商家店铺-属性} */
  getshopdetails({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/goods/detail/${opt.id}`, {params:{token:opt.token}}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  /**@param {根据商品标准名称判断接口} */
  getJudeGood({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.oneHttps.api}/goodsInfo/getJudgeGoodsName`, {params: opt}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  }

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}